import React from 'react';
import { Link } from 'react-router-dom';
import './MainFooter.css';

const MainFooter = () => {
  return (
    <footer className="footer">
      <div className="container">
        {/* Top Section */}
        <div className="footer-top">
          <div className="contact-info">
            <Link
              to="/contact"
              className="contact-btn"
            >
              <span>✉</span> Contact us
            </Link>
            <span className="text">INDIA, Bangalore, Karnataka</span>
          </div>
        </div>

        {/* Footer Links */}
        <div className="footer-links">
          {/* Column 1 */}
          <div className="footer-column">
            <h6>ELEXYT SEO</h6>
            <Link
              to="/"
              onClick={() => {
                setTimeout(() => {
                  const el = document.getElementById("products");
                  if (el) {
                    el.scrollIntoView({ behavior: "smooth" });
                  }
                }, 200);
              }}
            >
              MarketPlace
            </Link>
            <Link to="/finance/sip">Financial Calculators</Link>
            <Link to="/contact">Free Demo</Link>
          </div>

          {/* Column 2 */}
          <div className="footer-column">
            <h6>COMPANY</h6>
            <a 
              href="https://elexyt.com/" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              About Us
            </a>
            <Link to="/contact">Contact us</Link>
          </div>

          {/* Column 3 */}
          <div className="footer-column">
            <h6>FOLLOW US</h6>
            <Link to="#">
              <i className="fab fa-x-twitter"></i> X (Twitter)
            </Link>
            <Link
              to="https://www.linkedin.com/company/104980686/admin/page-posts/published/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-linkedin"></i> LinkedIn
            </Link>
            <Link
              to="https://www.youtube.com/@ElexytTech"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-youtube"></i> YouTube
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MainFooter;